import { Box, Stack, Typography } from '@mui/material';
import { makeStyles } from '@mui/styles';
import CircleChart from '../circularChart';

const Banner = () => {
  const classes = useStyles();
  return (
    <Box className={classes.mainContainer}>
      <Box className={classes.container}>
        <Box>
          <Stack spacing={4}>
            <Typography className={classes.heading}>
              Token Allocation – Transparency Matters
            </Typography>
            <Typography className={classes.description}>
              Our team is dedicated to fairness and transparency. Only{' '}
              <strong>1%</strong> of the total token supply is allocated to the
              team, ensuring that the community remains the priority.
            </Typography>
          </Stack>
        </Box>
        <Box
          className={classes.chartContainer}
          sx={{
            maxWidth: { lg: '300px', md: '300px', sm: '200px', xs: '200px' },
            minWidth: { lg: '300px', md: '300px', sm: '200px', xs: '200px' },
          }}
        >
          <CircleChart />
        </Box>
      </Box>
    </Box>
  );
};

export default Banner;
const useStyles = makeStyles((theme) => ({
  mainContainer: {
    backgroundColor: '#E4D2BA',
    boxShadow: '0 8px 15px rgba(0, 0, 0, 0.3)',
    padding: '80px 10px',
    borderRadius: '10px',
  },

  container: {
    display: 'flex',
    justifyContent: 'space-evenly',
    alignItems: 'center',
    flexWrap: 'wrap',
  },
  chartContainer: {},
  heading: {
    fontFamily: 'Chewy !important',
    fontSize: '34px !important',
    color: '#5f3a19 !important',
  },
  description: {
    fontFamily: 'Chewy !important',
    fontSize: '18px !important',
    maxWidth: '500px',
    color: '#685843',
  },
  button: {
    backgroundColor: '#eaac64 !important',
    borderRadius: '10px !important',
    fontSize: '14px !important',
    fontWeight: '600',
    color: '#000000 !important',
    textTransform: 'capitalize !important',
    padding: '8px 15px !important',
    fontFamily: 'Chewy !important',
    '&:hover': {
      backgroundColor: '#F9A85C !important',
    },
  },
  btnContainer: {
    marginTop: '20px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
}));
